import { snakelize, camelize } from "../../../helpers/object"

export default ($axios: any) => ({
  // 강의 목록 조회
  async index(params?: any) {
    return camelize(await $axios.get(`/lecture`, snakelize({ params })))
  },

  // 비밀번호 확인
  async password(params: { domain: string, password: string }) {
    return camelize(await $axios.post(`/lecture/password`, snakelize(params)))
  },

  // 강의 시청 기록 생성
  async storeWatchHistory(data: any) {
    return camelize(await $axios.post(`/lecture/watch-history`, snakelize(data)))
  },
})
